import { CollectionInfoModel } from "projects/phdsoft/common/src/lib/models";
import { GaugingElement } from "../SectionElements/InspectionElements/gaugingElement";
import { Collection } from "./Collection";

export class InspectionCampaign extends Collection {

    // private _IsFinished: boolean;
    public get IsFinished(): boolean {
        return this.CollectionInfoModel.IsFinished;
    }
    public set IsFinished(v: boolean) {
        this.CollectionInfoModel.IsFinished = v;
    }

    private _loaded: boolean;
    public get loaded(): boolean {
        return this._loaded;
    }
    public set loaded(v: boolean) {
        this._loaded = v;
    }

    constructor(collectionInfoModel: any, date: Date) {
        super(date);
        this.CollectionInfoModel = collectionInfoModel;
        this.Type = 'InspectionCampaign';
        this.Guid = collectionInfoModel.CollectionId;

        // this.CollectionInfoModel.InsertionMethod = this.CollectionInfoModel.CurrentMethodId ?? (this.CollectionInfoModel as any).ResultList[0]?.InspectionMethodId;
        this.CollectionInfoModel.InspectionTypeId = this.CollectionInfoModel.InspectionTypeId ?? this.CollectionInfoModel.CurrentInspectionTypeId;
    }

    public get inspectionTypeId(): string {
        return this.CollectionInfoModel.InspectionTypeId ?? this.Elements.length > 0 ? (this.Elements[0] as GaugingElement).elementResult.InspectionTypeId : undefined;
    }

    public get inspectionMethodId(): string {
        return this.CollectionInfoModel.InspectionMethodId;
    }

    public get regionId(): string {
        return this.CollectionInfoModel.RegionId ?? this.CollectionInfoModel.BlobPaths[0]?.RegionId;
    }
    public set regionId(v: string) {
        this.CollectionInfoModel.RegionId = v;
    }

}
